import { Typography } from '@agro-club/agroclub-shared'
import { FC, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { BorderedItem } from 'views/components/BorderedItem/BorderedItem'
import { Card } from 'views/components/Card/Card'

const commonCellStyle = css`
  display: flex;
  ${Typography.bodyMedium}
  padding: 10px 12px;
`
const Label = styled.div`
  ${commonCellStyle}
  width: 150px;
  color: ${({ theme }) => theme.color.textSecondary60a};
`

const Value = styled.div`
  ${commonCellStyle}
  width: 360px;
  color: ${({ theme }) => theme.color.textPrimary900};
`

type Props = {
  editBtnId?: string
  editModalHandler?: () => void
  header: ReactNode
  options: { label: ReactNode; value: ReactNode }[]
}

export const SamplesCommonTable: FC<Props> = ({ header, options, editBtnId, editModalHandler }) => {
  return (
    <Card.Container padding="compact" disableShadow bordered>
      <Card.GapableContent>
        <div>{header}</div>

        <div style={{ whiteSpace: 'pre-wrap' }}>
          {options.map((opt, i) => (
            <BorderedItem
              key={i}
              hover={false}
              justifyContent="normal"
              alignItems="flex-start"
              padding={false}
              columnGap="none"
            >
              <Label>{opt.label}</Label>
              <Value>{opt.value}</Value>
            </BorderedItem>
          ))}
        </div>
      </Card.GapableContent>
      {editModalHandler && <Card.EditButton id={editBtnId} onClick={editModalHandler} />}
    </Card.Container>
  )
}
